<template>
  <BaseEdit
    @edit-confirm-action="updateEntry"
    @edit-cancel-action="resetForm"
    @edit-open-action="loadServerEntry(entry)"
    @clear-form-errors="clearFormErrors"
    ref="baseEdit"
    width="60%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :readOnly="readOnly"
    :modelNameSingular="modelNameSingular"
  >
    <template slot="editForm">
      <Form
        ref="form"
        :entry="editableEntry"
        :extraData="extraData"
        :seedPlotOperation="seedPlotOperation"
        :serviceProvision="serviceProvision"
        :executionOperation="executionOperation"
        :isEdit="isEdit"
        :originalEntry="originalEntry"
        :readOnly="readOnly"
        :modelNameSingular="modelNameSingular"
      />
    </template>
  </BaseEdit>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseEdit from "@shared_components/base_edit.vue";

export default {
  data() {
    return {
      loading: true,
      pageLoading: false,
      editableEntry: null,
      formErrors: [],
      extraData: null,
      originalEntry: null
    };
  },
  props: {
    entry: Object,
    executionOperation: Object,
    seedPlotOperation: Object,
    serviceProvision: Object,
    isEdit: { // utilizado para definir se o form é de edição
      type: Boolean,
      default: false
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    Form: Form,
    BaseEdit: BaseEdit
  },
  methods: {
    loadServerEntry: function(loadEntry) {
      // console.log(this.executionOperation, this.serviceProvision);
      if (this.executionOperation) {
        this.loadConsumedItemForExecutionOperation(loadEntry);
      }else if(this.seedPlotOperation){
        this.loadConsumedItemForSeedPlotOperation(loadEntry);
      } 
      else {
        this.loadConsumedItemForServiceProvision(loadEntry);
      }
    },
    loadConsumedItemForExecutionOperation: function(loadEntry) {
      this.originalEntry = loadEntry;
      this.editableEntry = _.cloneDeep(this.originalEntry);
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_CONSUMED_ITEM_FOR_EXECUTION_OPERATION_QUERY,
          variables: {
            operationTypeId: this.executionOperation.operationTypeId,
            periodIds: this.executionOperation.periodIdsAttribute
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.entry.validations = response.data.groundContext.exitConsumedItem.validations;
          this.extraData = response.data;

          if (this.entry.item) {
            if (!this.extraData.accountContext.availableItemsForConsumptionInExecutionOperation.some(item => item.id == this.entry.item.id)) {
              this.extraData.accountContext.availableItemsForConsumptionInExecutionOperation.push(this.entry.item);
            }
          }
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },
    loadConsumedItemForSeedPlotOperation: function(loadEntry) {
      this.loading = true;
      this.originalEntry = loadEntry;
      this.editableEntry = _.cloneDeep(this.originalEntry);
      this.$apollo
        .query({
          query: LOAD_CONSUMED_ITEM_FOR_SEED_PLOT_OPERATION_QUERY,
          variables: {
            operationTypeId: this.seedPlotOperation.operationTypeId,
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          // console.log("itens for executionOperation", response);
          // this.entry = response.data.groundContext.exitConsumedItem;
          this.extraData = response.data;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },
    loadConsumedItemForServiceProvision: function(loadEntry) {
      this.originalEntry = loadEntry;
      this.editableEntry = _.cloneDeep(this.originalEntry);
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_CONSUMED_ITEM_FOR_SERVICE_PROVISION_QUERY,
          variables: {
            serviceProvisionType: this.serviceProvision.type,
            serviceProvisionId: this.serviceProvision.id
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.entry.validations = response.data.groundContext.exitConsumedItem.validations;
          this.extraData = response.data;

          if (this.entry.item) {
            if (!this.extraData.accountContext.availableItemsForConsumptionInServiceProvision.some(item => item.id == this.entry.item.id)) {
              this.extraData.accountContext.availableItemsForConsumptionInServiceProvision.push(this.entry.item);
            }
          }
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },
    updateEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.pageLoading = true;
        Object.assign(this.originalEntry, this.editableEntry);
        this.pageLoading = false;
        this.$refs.baseEdit.closeDialog();
        this.$emit("entry-updated", this.editableEntry);
        this.resetForm();
      }
    },
    resetForm: function() {
      if (this.$refs.form) {
        this.$refs.form.resetFormInputs();
      }
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};

const LOAD_CONSUMED_ITEM_FOR_EXECUTION_OPERATION_QUERY = gql `
  query($operationTypeId: ID!, $periodIds: [ID!]!) {
    groundContext {
      exitConsumedItem {
        validations
      } 
    }
    accountContext {
      availableItemsForConsumptionInExecutionOperation(operationTypeId: $operationTypeId, periodIds: $periodIds) {
        id
        name
        unit {
          id
          name
        }
        brand {
          id
          name
        }
        typeText
        type
      }
    }
  }
`;

const LOAD_CONSUMED_ITEM_FOR_SEED_PLOT_OPERATION_QUERY = gql `
  query($operationTypeId: ID!) {
    accountContext {
      availableItemsForConsumptionInSeedPlotOperation(operationTypeId: $operationTypeId) {
        id
        name
        unit {
          id
          name
        }
        brand {
          id
          name
        }
        typeText
        type
      }
    }
  }
`;

const LOAD_CONSUMED_ITEM_FOR_SERVICE_PROVISION_QUERY = gql `
  query($serviceProvisionType: TypesEnum!, $serviceProvisionId: ID) {
    groundContext {
      exitConsumedItem {
        validations
      } 
    }
    accountContext {
      availableItemsForConsumptionInServiceProvision(serviceProvisionType: $serviceProvisionType, serviceProvisionId: $serviceProvisionId) {
        id
        name
        unit {
          id
          name
        }
        brand {
          id
          name
        }
        typeText
        type
      }
    }
  }
`;
</script>

<style scoped></style>
